// extracted by mini-css-extract-plugin
module.exports = {"rootArea":"AdministratingRightSidebar_rootArea__2WmLo"};